import { ComponentType } from "react";
import { Guid } from "@common/guid";
import { PaneSlot } from "../rail/Rail.styles";

export interface PaneDefinition<TProps> {
    /** The slot the pane opens in. A right pane never goes to the stage; a stage pane can collapse into the rail. */
    slot: PaneSlot;
    component: ComponentType<TProps>;
    /**
     * For a pane that saves as the user goes, so the page behind it has nothing to refresh on until the pane
     * goes: once it is closed or replaced, the page refreshes. A pane with a save button refreshes on save instead.
     */
    refetchPageWhenClosed?: boolean;
}

export function definePane<TProps>(definition: PaneDefinition<TProps>): PaneDefinition<TProps> {
    return definition;
}

/**
 * A pane once it is open. `never` rather than a props type because an open pane may be any pane, and a
 * definition of any props is assignable to one that accepts none. instanceId keys the pane, so opening a
 * second obligation over the first mounts a fresh form instead of inheriting the first one's state.
 */
export interface OpenPane {
    definition: PaneDefinition<never>;
    props: object;
    instanceId: string;
    /** The pane that opened this one as its own, which takes it along when it leaves. Unset for a pane a page opened. */
    ownerInstanceId?: string;
}

export function toOpenPane<TProps>(definition: PaneDefinition<TProps>, props: TProps, ownerInstanceId?: string): OpenPane {
    return { definition: definition as PaneDefinition<never>, props: props as object, instanceId: Guid.newGuid(), ownerInstanceId };
}
